import { Component, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { OnyxIconButtonComponent } from '../../../components/buttons/onyx-icon-button/onyx-icon-button.component';
import { OnyxFlagComponent } from '../../../components/flags/onyx-flag/onyx-flag.component';
import { OnyxFlagsComponent } from '../../../components/flags/onyx-flags/onyx-flags.component';
import { OnyxIconComponent } from '../../../components/icons/onyx-icon/onyx-icon.component';
import type { OnyxRouteBorder } from '../../../components/map/interfaces';
import { ActionHelper, CoordinatesHelper } from '../../../helpers';
import { OnyxToastService } from '../../../services/onyx-toast.service';
import { I18N_NAMESPACE } from '../../constants';

@Component({
  selector: 'onyx-onyx-border-tooltip',
  imports: [
    TranslatePipe,
    OnyxFlagsComponent,
    OnyxFlagsComponent,
    OnyxIconComponent,
    OnyxFlagComponent,
    OnyxIconButtonComponent,
  ],
  templateUrl: './onyx-border-tooltip.component.html',
  styleUrl: './onyx-border-tooltip.component.scss',
})
export class OnyxBorderTooltipComponent {
  private readonly toastService = inject(OnyxToastService);

  public readonly border = input.required<OnyxRouteBorder>();

  protected readonly I18N = `${I18N_NAMESPACE}.border`;

  protected copyCoordinates(): void {
    const coordinates = CoordinatesHelper.toString(this.border().coordinates);
    if (coordinates) ActionHelper.copy(coordinates, this.toastService);
  }
}
